var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header", attrs: { id: "header" } },
    [_c("csm-banner"), _c("top-bar"), _c("main-bar"), _c("nav-bar")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }